window.OVERTIME_CONSECUTIVE_DAY_VALUES = {
    CONSECUTIVE_DAY_DEFAULT: 'CONSECUTIVE_DAY_DEFAULT',
    CONSECUTIVE_DAY_DOT: 'CONSECUTIVE_DAY_DOT',
    CONSECUTIVE_DAY_WORKED_HOURS_THRESHOLD: 'CONSECUTIVE_DAY_WORKED_HOURS_THRESHOLD'
}